<template>
  <b-taginput
    :value="formattedValue"
    autocomplete
    :icon="icon"
    :placeholder="placeholder"
    :field="field"
    :maxtags="maxtags"
    :maxlength="maxlength"
    :has-counter="hasCounter"
    :loading="isFetching"
    :check-infinite-scroll="true"
    :data="data"
    :open-on-focus="openOnFocus"
    @input="$emit('input', $event)"
    @typing="onTyping"
    @infinite-scroll="onScrollBottom"
  />
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      validator(value) {
        return _.isArray(value) || value == null;
      }
    },
    placeholder: {
      default: "",
      type: String
    },
    route: {
      required: true,
      type: String
    },
    field: {
      default: undefined,
      type: String
    },
    icon: {
      default: "label",
      type: String
    },
    maxtags: {
      type: Number,
      default: undefined
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    openOnFocus: {
      type: Boolean,
      default: false
    },
    keepFirst: {
      type: Boolean,
      default: true
    },
    param: {
      default: "search",
      type: String
    },
    hasCounter: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      query: "",
      page: 0,
      stopScroll: false,
      data: [],
      isFetching: false
    };
  },
  computed: {
    formattedValue () {
      return _.isArray(this.value) ? this.value : [];
    }
  },
  methods: {
    onTyping (query) {
      this.query = query;
      this.page = 1;
      this.stopScroll = false;
      this.$emit("typing", query);
      this.getAsyncData();
    },
    getAsyncData: _.debounce(function () {
      if (!_.isString(this.query) || !this.query.length) {
        this.data = [];
        return;
      }
      this.fetch();
    }, 500),
    onScrollBottom () {
      this.page++;
      if (this.stopScroll == false) {
        this.fetch();
      }
    },
    fetch () {
      this.isFetching = true;
      this.$http.get(`${this.route}?${this.param}=${this.query}&page=${this.page}`)
        .then(({ data }) => {
          if (this.page == 1) {
            this.data = [];
          }

          let items = data;
          if (_.isObject(items)) {
            items = items.data;
          }

          items.forEach((item) => this.data.push(item));

          if (items.length == 0) {
            this.stopScroll = true;
          }
        })
        .catch((error) => {
          this.data = [];
          throw error;
        })
        .finally(() => {
          this.isFetching = false;
        });
    }
  }
};
</script>
